<script setup lang="ts">
import {nextTick, onMounted, watch} from 'vue';
import {initAos, refreshAos} from '~/utils/initAos';

const route = useRoute();

onMounted(() => {
    initAos({
        once: true,
        duration: 850,
        easing: 'ease-out-cubic',
        offset: 120,
    });
});

watch(
    () => route.fullPath,
    async () => {
        await nextTick();
        refreshAos({resetFooter: true});
    },
);
</script>

<template>
    <NuxtLayout>
        <NuxtPage />
    </NuxtLayout>
</template>

<style lang="scss">
@import "assets/styles/scss/index";
</style>
